/* eslint-disable react-hooks/exhaustive-deps */
import './style.css';
import React from 'react';
import Footer from '../../Components/Footer';
import AllProducts from '../../Components/allProducts';
import ScrollToTop from '../../Components/scrollup';
import ProductNav from '../../Components/productNav';
import ScrollPage from '../../Components/scrollpageUp'
import { cardData } from '../../Data/cardData';
import slugify from '../../Utils/slugify'
const findLabel = (slug = "") => {
  if (!slug || typeof slug !== "string") return "";

  for (const cat of cardData) {
    if (slugify(cat.title) === slug) return cat.title;

    for (const sub of cat.sousFamille || []) {
      if (slugify(sub.nom) === slug) return sub.nom;

      for (const sub2 of sub.sousFamilles || []) {
        if (slugify(sub2.nom) === slug) return sub2.nom;

        for (const sub3 of sub2.sousSousFamilles || []) {
          if (typeof sub3 === "object") {
            if (slugify(sub3.nom) === slug) return sub3.nom;
          } else {
            if (slugify(sub3) === slug) return sub3;
          }
        }
      }
    }
  }

  return slug ? slug.replace(/-/g, " ") : "";
};
// 1. On remplace cartCount par onAddToCart
export default function Products({ onAddToCart }) {
  const [paths, setPaths] = React.useState([]);

  React.useEffect(() => {
    const segments = window.location.pathname
      .split("/")
      .filter(Boolean)
      .map(decodeURIComponent);

    // remove "collections"
    const clean = segments.slice(1);

    setPaths(clean);
  }, []);

const getTitle = () => {
  for (let i = paths.length - 1; i >= 0; i--) {
    if (!paths[i]) continue;

    const label = findLabel(paths[i]);
    if (label) return label;
  }

  return "Produits";
};

  return (
    <div className="products" id="produits">
      <ScrollPage />

      <div className="product">
        <ScrollToTop />

        <div className="nav">
          <ProductNav />
        </div>

        <div className="productContain">

          {/* TITLE FIXÉ */}
          <h2 className="pathTitle">
            {getTitle()}
          </h2>

          {/* PRODUCTS */}
          <AllProducts
            sousSouscategName={paths[3] || ""}
            souscategName={paths[2] || ""}
            categName={paths[1] || ""}
            familyName={paths[0] || ""}
            onAddToCart={onAddToCart}
          />

        </div>
      </div>

      <Footer />
    </div>
  );
}